/**
 * A versão do motor CPTu (RN-252).
 *
 * É a versão da CONTA: muda quando muda qualquer resultado numérico do motor
 * (fórmula, arredondamento, regra de aplicabilidade). Cada emissão guarda a
 * versão com que foi calculada, e a conformidade com o gabarito 2609350 (o
 * `conformidade.ts`, gerado) vale para esta versão e para nenhuma outra.
 * Mudar a interface sem mudar o número não pede nova versão; mudar o número
 * sem refazer a conformidade, sim.
 */
export const MOTOR_CPTU_VERSAO = '1.0.0';
